<mat-card>
  <mat-card-header>
    <mat-card-title> GALERIA </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-grid-list cols="7" rowHeight="9:7">
      <mat-grid-tile
        matRipple
        class="ripple-image mat-elevation-z4"
        (click)="openDialog()"
        [colspan]="7"
        [rowspan]="7"
        [style.background]="'#000000'"
      >
        <img mat-card-image src="{{ src_img }}" style="object-fit: contain" />
      </mat-grid-tile>

      <mat-grid-tile
        matRipple
        class="ripple-image mat-elevation-z4"
        [colspan]="1"
        [rowspan]="1"
        [style.background]="'#F2F4F4'"
        *ngFor="let image of image_list; let i = index"
        (click)="fnShow(i)"
      >
        <img
          *ngIf="image"
          mat-card-image
          src="{{ image }}"
          style="object-fit: contain"
        />
      </mat-grid-tile>
    </mat-grid-list>
  </mat-card-content>
</mat-card>
